import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateSetting as UpdateSettingMutation,
    UpdateSettingVariables as UpdateSettingMutationVariables,
} from 'nutshell-graphql-types';

import SESSION_USER_FRAGMENT from '../../../graphql/fragments/session-user-fragment.graphql';
import UPDATE_SETTING from '../../../graphql/mutations/update-setting.graphql';

import {getWidgetSettingName} from '../../helpers';
import type {CardWidgetKey} from '../../types';

export function useUpdateWidgetCollapsed(): (arg1: {
    userId: string;
    widgetKey: CardWidgetKey;
    value: string;
}) => Promise<any> {
    const [updateSetting] = useMutation<UpdateSettingMutation, UpdateSettingMutationVariables>(
        UPDATE_SETTING
    );

    return (input: {userId: string; widgetKey: CardWidgetKey; value: string}) => {
        const settingName = getWidgetSettingName(input.widgetKey);

        return updateSetting({
            variables: {
                setting: {
                    name: settingName,
                    value: input.value,
                    isGlobal: false,
                },
            },
            optimisticResponse: {
                __typename: 'Mutation',
                updateSetting: {
                    __typename: 'UpdateSettingPayload',
                    setting: {
                        __typename: 'Setting',
                        id: 'temp',
                        // @ts-expect-error
                        name: settingName,
                        value: input.value,
                        isGlobal: false,
                    },
                },
            },
            update: (proxy, mutationResults) => {
                const userFragment = proxy.readFragment({
                    id: input.userId,
                    fragmentName: 'SessionUser',
                    fragment: SESSION_USER_FRAGMENT,
                });

                if (userFragment) {
                    const newSetting =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.updateSetting &&
                        mutationResults.data.updateSetting.setting;

                    if (!newSetting) return;

                    const newValue = Boolean(newSetting.value === '1');

                    const data = {
                        ...userFragment,
                        __typename: 'User',
                    } as const;

                    // @ts-expect-error
                    if (data.widgetsCollapsedState) {
                        // @ts-expect-error
                        data.widgetsCollapsedState = {
                            // @ts-expect-error
                            ...data.widgetsCollapsedState,
                            [input.widgetKey]: newValue,
                        };
                    } else {
                        // @ts-expect-error
                        data.widgetsCollapsedState = {
                            __typename: 'WidgetsCollapsedState',
                            [input.widgetKey]: newValue,
                        };
                    }

                    proxy.writeFragment({
                        id: input.userId,
                        fragmentName: 'SessionUser',
                        fragment: SESSION_USER_FRAGMENT,
                        data: data,
                    });
                }
            },
        });
    };
}
